module.exports = __webpack_public_path__ + "static/media/react.4009eef3.svg";